import { Component, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { first } from 'rxjs';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, RouterLink],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {
  userName = '';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService
      .amplifyGetUserSession()
      .pipe(first())
      .subscribe((session: any) => {
        const givenName = session?.tokens?.idToken?.payload?.given_name ?? '';
        const middleName = session?.tokens?.idToken?.payload?.middle_name ?? '';

        this.userName = [givenName, middleName].filter(Boolean).join(' ');
      });
  }
}
